__turbopack_context__.v({
  "Tooltip": "iJsYkG_Tooltip",
  "Wrapper": "iJsYkG_Wrapper",
  "bottom": "iJsYkG_bottom",
  "fadeIn": "iJsYkG_fadeIn",
  "left": "iJsYkG_left",
  "right": "iJsYkG_right",
  "skeleton-loading": "iJsYkG_skeleton-loading",
  "top": "iJsYkG_top",
});
